/**
 * InviteEmployeeControl
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { EMPLOYEE_ROLE } from 'containers/User/constants.js';
import messages from '../messages.js';
import InviteFrame from '../InviteUsers/InviteFrame.jsx';
import EmailInvite from '../InviteUsers/EmailInvite/index.jsx';

function InviteEmployeeControl(props) {
  const { user, ...rest } = props;
  const { id, accountName, firstName, uniqueId, roleType } = user;
  const [show, setShow] = useState(false);
  if (uniqueId || roleType !== EMPLOYEE_ROLE) {
    return null;
  }
  const printLink = `#print/employee/${id}`;

  return (
    <>
      <Button onClick={() => setShow(!show)} {...rest}>
        <FormattedMessage {...messages.invite} />
      </Button>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title><FormattedMessage {...messages.inviteEmployeeTitle} values={{ name: accountName }} /></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p><FormattedMessage {...messages.inviteEmployeeIntro} values={{ name: firstName }} /></p>
          <InviteFrame>
            <InviteFrame.Print>
              <p className="form-text"><FormattedMessage {...messages.invitePrintHelp} values={{ roleName: 'employee' }} /></p>
              <Button variant="primary" className="my-5" href={printLink}><FormattedMessage {...messages.invitePrintButton} /></Button>
            </InviteFrame.Print>
            <InviteFrame.Email>
              <EmailInvite roleName="employee" userId={id} onClose={() => setShow(false)} />
            </InviteFrame.Email>
          </InviteFrame>
        </Modal.Body>
      </Modal>
    </>
  );
}

InviteEmployeeControl.propTypes = {
  user: PropTypes.object.isRequired,
};

export default InviteEmployeeControl;
